import React, { useEffect, useRef } from 'react'
import { Header, Modal, Button, Icon, Item, Grid } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import Calendar from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import fa from "react-date-object/locales/persian_fa"
import { SetStartDate, SetEndDate } from "../../../../redux/actions/mainActions"
import { useSelector, useDispatch } from 'react-redux';
import bgimg from "../../../../assets/images/bg-stripped.jpeg"

import "./AccommodationAvailableDates.css"

const AccommodationAvailableDates = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const calendarRef = useRef(null);
    const lang = useSelector((state) => state.main.lang)

    useEffect(() => {
        calendarRef.current.openCalendar()
    }, [])
    const renderDatePicker = () => {

        return lang === "fa-IR" ?
            <Calendar
                className="no-input"
                ref={calendarRef}
                onClose ={false}
                onChange={(date) => {
                    dispatch(SetStartDate(new Date(date[0]).toLocaleDateString('fa-IR')))
                    if (new Date(date[1]).toLocaleDateString('fa-IR') != "Invalid Date") {
                        dispatch(SetEndDate(new Date(date[1]).toLocaleDateString('fa-IR')))
                    }
                }}
                range
                mapDays={({ date }) => {
                    var today = new Date()

                    if (date < today) return {
                        disabled: true,
                        style: { backgroundImage: `url(${bgimg})`, backgroundSize: "contain" },
                    }
                }}
                numberOfMonths={1}
                calendar={persian}
                locale={fa}
                arrow={false}
                fixMainPosition={true}
                fixRelativePosition={true}
        
            />
            : <Calendar
            className="no-input"
            arrow={false}
                ref={calendarRef}
                onClose ={false}
                fixMainPosition={true}
                fixRelativePosition={true}
                onChange={(date) => {
                    dispatch(SetStartDate(new Date(date[0]).toLocaleDateString('fa-IR')))
                    if (new Date(date[1]).toLocaleDateString('fa-IR') != "Invalid Date") {
                        dispatch(SetEndDate(new Date(date[1]).toLocaleDateString('fa-IR')))
                    }
                }}
                range
                mapDays={({ date }) => {
                    var today = new Date()

                    if (date < today) return {
                        disabled: true,
                        style: { backgroundImage: `url(${bgimg})`, backgroundSize: "contain" },
                    }
                }}
                numberOfMonths={1}
                calendar={persian}
                locale={fa}
            />


    }


    return (<div className="AccommodationAvailableDates">
        <Header as='h3'>{t("property:SelectATravelDate")}</Header>
        {renderDatePicker()}

    </div>
    )
}
export default AccommodationAvailableDates